<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import Cleave from 'cleave.js'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import FormsApi from '../../api/FormsApi'
import ReportingEntityApi from '../../api/ReportingEntityApi'
import ReportingUnitApi from '../../api/ReportingUnitApi'
import ValidationPeriodApi from '../../api/ValidationPeriodApi'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Datepicker } from 'buefy/dist/components/datepicker'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Radio } from 'buefy/dist/components/radio'
import { Select } from 'buefy/dist/components/select'
import { Switch } from 'buefy/dist/components/switch'
import { Table,TableColumn } from 'buefy/dist/components/table'
import { Upload } from 'buefy/dist/components/upload'
import { Message } from 'buefy/dist/components/message'

/**
 * We add a new instance of Cleave when the element
 * is bound and destroy it when it's unbound.
 */
const cleave = {
    name: 'cleave',
    bind(el, binding) {
        const input = el.querySelector('input')
        input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
        const input = el.querySelector('input')
        input._vCleave.destroy()
    }
}



const VPERIOD_READY_STATUS = 'Ready';
const VPERIOD_OPEN_STATUS = 'Open';
const VPERIOD_CLOSED_STATUS = 'Closed';

export default {
    name : "PreviewFromView",
    components: {
        'b-checkbox' : Checkbox,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-datepicker' : Datepicker,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-radio' : Radio,
        'b-select' : Select,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'b-upload' : Upload,
        'b-message' : Message
    },
    directives: { cleave },
    data() {
        return {
            formId : null,
            formPreviewData : {},
            viewAs : null,
            presetLovs: {
                'Reporting Entities' : [],
                'Reporting Entities & Units' : []
            },
            masks: {
                numeral: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                    prefix: '',
                    rawValueTrimPrefix : true
                }
            },
            selectedReportingYear : null,
            globalLoading: null,
            validationPeriod: null
        }
    },
    computed: {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        selectedFormAccessData() {
            if (this.formPreviewData) {
                if (this.formPreviewData.formAccessData) {
                    if (this.formPreviewData.formAccessData.reportingEntities) {
                        var selected = this.formPreviewData.formAccessData.reportingEntities.filter(access=>{
                            return (access.accessId==this.viewAs)
                        });
                        if (selected.length > 0) {
                            if (selected[0]) {
                                return selected[0];
                            }
                        }
                    }
                }
            }
            return null;
        },
        groupedFields(){
             if (this.formPreviewData!==null) {

                var currFieldGroup=null;
                var newGroupedFields = [];

                this.formPreviewData.formFields.forEach(field=>{
                    if (field.fieldGroupLabel==currFieldGroup && field.fieldGroupLabel!="") {
                        newGroupedFields[newGroupedFields.length-1].fields.push(field)
                    }
                    else {
                        newGroupedFields.push({
                            fieldGroupName: field.fieldGroupLabel,
                            fieldGroupSubLabel: field.fieldGroupSubLabel ? field.fieldGroupSubLabel : '',
                            fields : [field]
                        })
                    }
                    currFieldGroup = field.fieldGroupLabel;
                });

                return newGroupedFields;
            }
        },
        vperiodOpen() {
            if (this.validationPeriod) {
                if (this.validationPeriod.vPeriodStatus === VPERIOD_OPEN_STATUS) {
                    return true
                }
            }
            return false
        },
        vperiodReady() {
            if (this.validationPeriod) {
                if (this.validationPeriod.vPeriodStatus === VPERIOD_READY_STATUS) {
                    return true
                }
                return false
            }
            return true
        },
        vperiodClosed() {
            if (this.validationPeriod) {
                if (this.validationPeriod.vPeriodStatus === VPERIOD_CLOSED_STATUS) {
                    return true
                }
            }
            return false
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        // this.isTokenValid();
        if (this.$route.params) {
            try {
                this.formId = parseInt(this.$route.params.formId,10)
            }
            catch(formIdError){}
        }
        
        if (this.$route.query) {
            try {
                if (this.$route.query.reportingYear) {
                    this.selectedReportingYear = parseInt(this.$route.query.reportingYear,10);
                }
            }
            catch(repYrErr){}
        }

        if (this.formId!=null) {
            this.getForm();
            this.getPresetLovs();
        }
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                            }
                        }
                    }
                } 
            })
            .catch(error=>{
            })
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getForm(){
            this.showLoading()
            FormsApi.getOne(this.formId)
            .then(response=>{
                if (response.data) {
                    this.closeLoading()
                    if (!response.data.error) {
                        this.formPreviewData = response.data;
                        if (response.data.reportingYear) {
                            this.getValidationPeriod(response.data.reportingYear)
                        }
                        this.initViewAs();
                    }
                    else {
                        this.promptServerError({response},'Form.getOne');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'Form.getOne');
            });
        },
        getValidationPeriod(formYear){
            this.validationPeriod = null;
            ValidationPeriodApi.get({
                reportingYear : formYear,
                status : ''
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length == 0) {
                            // No validation period
                        }
                        else {
                            if (response.data[0]) {
                                this.validationPeriod  = response.data[0]
                            }  
                        }
                    } 
                    else {
                        this.promptServerError({response},'ValidationPeriod.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ValidationPeriod.get');
            })
        },
        getPresetLovs(){
            this.presetLovs['Reporting Entities'] = [];
            this.presetLovs['Reporting Entities & Units'] = [];

            /* Reporting Entities Preset */ 
            ReportingEntityApi.get('active')
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.presetLovs['Reporting Entities'] = response.data;
                    }
                    else {
                        this.promptServerError({response},'ReportingEntity.get');
                        return false;
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.get');
                return false;
            });

            /* Reporting Entities & Units Preset */ 
            ReportingUnitApi.getUnitsEntities()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.presetLovs['Reporting Entities & Units'] = response.data;
                    }
                    else {
                        this.promptServerError({response},'ReportingUnit.getUnitsEntities');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingUnit.getUnitsEntities');
            });
        },
        initViewAs(){
            if (this.formPreviewData.groupedFormAccessData.length > 0) {
                this.formPreviewData.groupedFormAccessData.forEach((group,groupIdx)=>{
                    if (groupIdx==0) {
                        if (group.reportingEntities.length > 0) {
                            group.reportingEntities.forEach((entity,entityIdx)=>{
                                if (entityIdx==0) {
                                    this.viewAs = entity.accessId;
                                    return
                                }
                            })
                        }
                    }
                })
            }
        },
        openEditForm(){
            this.$router.push({path:"/admin/forms/"+this.formPreviewData.formId+'/edit?reportingYear='+this.selectedReportingYear});
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        setFieldLabel(field) {
            let label = field.fieldLabel //+' ('+fieldeldSubLabel+')'
            if (field.fieldSubLabel) {
                // label += ` (${field.fieldSubLabel})`
            }
            if (field.isRequired==true) {
                label = '*'+label;
            }
            return label;
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            this.globalLoading.close()
            this.globalLoading = null
        }
    }
}
</script>

<template>
    <section>
        <div class="base-box--sidepadded">
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a 
                            v-if="selectedReportingYear"
                            v-bind:href="'#/admin/forms?reportingYear='+selectedReportingYear">
                            Forms
                        </a>
                    </li>
                    <li class="is-active"><a href="#" aria-current="page">Preview</a></li>
                </ul>
            </nav>
        </div>


        <div class="field is-grouped">
            <div class="control">
                <p class="subtitle page-title">{{formPreviewData.formName}}</p>
            </div>
            <p class="control">
                <button type="button"
                    class="button is-primary is-inverted"
                    v-bind:disabled="formPreviewData.isPublished==true || !vperiodReady"
                    v-on:click="openEditForm"
                    style="margin-top:0.8em;">
                    <span class="icon">
                        <i class="fas fa-pen"></i>
                    </span>
                    <span>Edit</span>
                </button>
            </p>
        </div>
           
        
        <div class="section no-padd--top">
            
            <!-- Filter Options /Search -->
            <div class="columns"
                v-if="selectedFormAccessData && formPreviewData">
                <div class="column">
                    <div class="field is-grouped">
                        <b-field 
                            label="View as:"
                            :label-position="'on-border'">
                            <b-select placeholder="View as"
                                icon="eye"
                                v-model="viewAs">
                                <optgroup 
                                    v-for="(groupAccess,idx) in formPreviewData.groupedFormAccessData"
                                    v-bind:key="idx"    
                                    v-bind:label="groupAccess.reportingGroup">
                                    <option 
                                        v-for="(entityAccess,eIdx) in groupAccess.reportingEntities"
                                        v-bind:key="eIdx"
                                        v-bind:value="entityAccess.accessId">{{entityAccess.reportingEntity}}</option>
                                </optgroup>
                            </b-select>
                        </b-field>
                        <span class="is-italic has-text-grey"
                            v-if="selectedFormAccessData"
                            style="margin-left:0.65em;margin-top:0.3rem;">*This is how 
                            <span class="has-text-weight-bold">{{formPreviewData.formName}}</span> 
                            form would look like when accessed by users from 
                            <span class="has-text-weight-bold">{{selectedFormAccessData.reportingEntity}}</span>.
                        </span>
                        <!-- <p class="control">
                            <span class="tag"
                                style="margin-top:0.5em;"
                                v-if="selectedFormAccessData"
                                v-bind:class="selectedFormAccessData.repGroupTagClass">{{selectedFormAccessData.reportingGroup}}</span>
                        </p> -->
                    </div>
                </div>
            </div>

            <section class="section no-padd app-view app-view--admin">
                
                <!-- Workspace/Form View -->
                <div class="column ">
                    
                    <div
                        v-if="selectedFormAccessData"
                        class="box">
    
                        <!-- Form + Save Actions -->
                        <div class="columns">

                            <div class="column">
                                <span class="heading">Form Name</span>
                                <p class="title">{{formPreviewData.formName}}</p>
                            </div>

                            <div class="column has-text-right">
                                <a class="button is-light"
                                    v-if="selectedFormAccessData.formSubmissionType=='Multiple' &&
                                    selectedFormAccessData.displayOption=='List'">
                                    <span class="icon">
                                        <i class="fas fa-plus"></i>
                                    </span>
                                    <span>Add New Form Entry</span>
                                </a>

                                
                                <!-- <a class="button is-success"
                                    v-on:click="saveForm">
                                    <span class="icon">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span>Save Form Entry</span>
                                </a> -->
                            </div>
                            
                            <!-- Hide display option switch in Form Preview
                            <div class="is-divider-vertical ore-divider--vertical" data-content=""></div>
                            <div class="column has-text-left is-1">
                                <a class="button is-info"
                                    v-if="selectedFormAccessData.displayOption=='List'"
                                    v-bind:class="{'is-outlined':selectedFormAccessData.displayOption!=='List'}">
                                    <span class="icon">
                                        <i class="fas fa-th-list"></i>
                                    </span>
                                </a>
                            
                                <a class="button is-info"
                                    v-if="selectedFormAccessData.displayOption=='Table'"
                                    v-bind:class="{'is-outlined':selectedFormAccessData.displayOption!=='Table'}">
                                    <span class="icon">
                                        <i class="fas fa-columns"></i>
                                    </span>
                                </a>
                            </div> -->
                        </div>

                        <!-- Display Options -->
                        <div class="columns">
                        </div>

                        <!-- Fields -->
                        <section class="main-form-body">

                            <div v-if="selectedFormAccessData.displayOption=='List'">
                                
                                <div 
                                    class="field-group-box"
                                    v-for="(grp,grpIdx) in groupedFields"
                                    v-bind:key="grpIdx">

                                    

                                    <p class="subtitle"
                                        v-if="grp.fieldGroupName!=''"
                                        style="margin-bottom:0.4rem">{{grp.fieldGroupName}}
                                    </p>

                                    <p class="is-7"
                                        v-if="grp.fieldGroupSubLabel!=null && grp.fieldGroupSubLabel!=''"
                                        style="margin-bottom:0.9rem">{{grp.fieldGroupSubLabel}}</p>

                                    <div 
                                        v-for="(field,fieldIdx) in grp.fields"
                                        v-bind:key="fieldIdx">
                                        
                                        <!-- *** INPUT TEXTS *** -->
                                        <div class="form-field-label">
                                            <span class="has-text-weight-bold">{{setFieldLabel(field)}}</span>
                                            <span v-if="field.fieldSubLabel"><br/>{{field.fieldSubLabel}}</span>
                                        </div>
                                                    
                                        <!-- Textfield -->
                                        <b-field
                                            v-if="field.inputType=='textfield'"
                                            class="form-field-input">
                                            <b-input 
                                                type="text"
                                                disabled></b-input>
                                        </b-field>

                                        <!-- Textarea -->
                                        <b-field
                                            v-if="field.inputType=='textarea'"
                                            class="form-field-input">
                                            <b-input 
                                                maxlength="200" 
                                                type="textarea"
                                                disabled></b-input>
                                        </b-field>

                                        <!-- *** NUMBER INPUTS *** -->

                                        <!-- Number -->
                                        <b-field
                                            v-if="field.inputType=='number'"
                                            class="form-field-input">
                                            <b-input  
                                                type="number"
                                                min="0"
                                                disbaled></b-input>
                                        </b-field>

                                        <!-- Decimal -->
                                        <b-field
                                            v-if="field.inputType=='decimal'"
                                            class="form-field-input">
                                            <b-input  
                                                type="text" 
                                                v-bind:value="''"
                                                v-cleave="masks.numeral"
                                                disabled></b-input>
                                        </b-field>

                                        <!-- Integer -->
                                        <b-field
                                            v-if="field.inputType=='integer'"
                                            class="form-field-input">
                                            <b-input  
                                                type="number"
                                                disabled></b-input>
                                        </b-field>

                                        
                                        <!-- *** SELECTION INPUTS / WITH OPTIONS *** -->

                                        <!-- Yes or No -->
                                        <b-field
                                            v-if="field.inputType=='yes or no'"
                                            class="form-field-input">
                                            <div class="buttons has-addons"
                                                v-if="field.inputType=='yes or no'">
                                                <span class="button"
                                                    disabled>Yes</span>
                                                <span class="button"
                                                    disabled>No</span>
                                            </div>
                                        </b-field>

                                        <!-- Dropdown -->
                                        <b-field
                                            v-if="field.inputType=='dropdown' && field.options.length"
                                            class="form-field-input">
                                            <!-- Custom Options -->
                                            <b-select
                                                v-if="field.optionType=='custom' && field.options.length > 0"
                                                disabled>
                                                <option v-for="opt in field.options"
                                                    v-bind:key="opt.optionId"
                                                    v-bind:value="opt.optionValue">
                                                    {{opt.optionValue}}
                                                </option>
                                            </b-select>

                                            <!-- Preset Options -->
                                            <b-select
                                                v-if="field.optionType=='preset' && field.options.length==1 && 
                                                field.options[0].optionValue=='Reporting Entities'"
                                                disabled>
                                                <option 
                                                    v-for="(opt,optIdx) in presetLovs['Reporting Entities']"
                                                    v-bind:key="optIdx"
                                                    v-bind:value="opt.optionValue">
                                                    {{opt.optionLabel}}
                                                </option>
                                            </b-select>

                                            <b-select
                                                v-if="field.optionType=='preset' && field.options.length==1 && 
                                                field.options[0].optionValue=='Reporting Entities & Units'"
                                                disabled>
                                                <option 
                                                    v-for="(opt,optIdx) in presetLovs['Reporting Entities & Units']"
                                                    v-bind:key="optIdx"
                                                    v-bind:value="opt.optionValue"
                                                    disabled>
                                                    {{opt.optionLabel}}
                                                </option>
                                            </b-select>
                                            
                                        </b-field>

                                        <!-- Checkbox -->
                                        <b-field
                                            v-if="field.inputType=='checkbox' && field.options.length"
                                            class="form-field-input">
                                            <div class="block checkbox-block">
                                                <b-checkbox v-for="opt in field.options"
                                                    v-bind:key="opt.optionId"
                                                    v-bind:native-value="opt.optionValue"
                                                    disabled>
                                                    {{opt.optionValue}}
                                                </b-checkbox>
                                            </div>
                                        </b-field>

                                        <!-- Radio -->
                                        <b-field
                                            v-if="field.inputType=='radio' && field.options.length"
                                            class="form-field-input">
                                            <div class="block radio-block">
                                                <b-radio 
                                                    v-for="opt in field.options"
                                                    v-bind:key="opt.optionId"
                                                    v-bind:name="'radio'+field.fieldId"
                                                    v-bind:native-value="opt.optionValue"
                                                    disabled>
                                                    {{opt.optionValue}}
                                                </b-radio>
                                            </div>
                                        </b-field>

                                        <!-- *** DATE INPUT *** -->

                                        <!-- Date Inputs -->
                                        <b-field
                                            v-if="field.inputType=='date' || 
                                            field.inputType=='date range (start date)' ||
                                            field.inputType=='date range (end date)'"
                                            class="form-field-input">
                                            <b-datepicker
                                                v-bind:show-week-number="true"
                                                placeholder="Click to select date"
                                                icon="calendar-today"
                                                disabled>
                                            </b-datepicker>
                                        </b-field>
                                        
                                    </div>

                                </div>

                                <hr v-if="formPreviewData && formPreviewData.filesEnabled && selectedFormAccessData.displayOption=='List'"/>

                                <div
                                    v-if="formPreviewData && formPreviewData.filesEnabled && selectedFormAccessData.displayOption=='List'" 
                                    class="box">
                                    <h3 class="subtitle is-6 has-text-weight-bold">Add Supporting Schedules and Documents</h3>
                                    <b-message 
                                        type="is-info">
                                        <ul>
                                            <li>- Only .pdf, .ppt/.pptx, .doc/docx, and .xls/xlsx are supported.</li>
                                            <li>- Multiple files can be uploaded but not more than a total of 20 files.</li> 
                                            <li>- Total file size should NOT be more than 100MB.</li>
                                            <li>- In case total file size exceeds 100MB, remove a few files then upload again after clicking 'Save'.</li>
                                            <li>- Files with the same filename will be overwritten upon selection</li> 
                                            <li>- DO NOT CLOSE this page while upload is in progress.</li>
                                        </ul>
                                    </b-message>
                                    
                                    <b-field>
                                        <b-upload
                                            multiple
                                            drag-drop
                                            disabled>
                                            <section class="section">
                                                <div class="content has-text-centered">
                                                    <p>
                                                        <b-icon
                                                            icon="upload"
                                                            size="is-large">
                                                        </b-icon>
                                                    </p>
                                                    <p>Drop your files here or click to upload</p>
                                                </div>
                                            </section>
                                        </b-upload>
                                    </b-field>

                                </div>

                            </div>

                            <div v-if="selectedFormAccessData.displayOption=='Table'"
                                class="ore-table-wrapper ore-table-wrapper--admin">
                                <table class="ore-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(col,colIdx) in formPreviewData.formFields"
                                                v-bind:key="colIdx">
                                                <span v-if="col.fieldGroupLabel" class="form-field-grouplabel-th">{{col.fieldGroupLabel}} - </span>
                                                {{col.fieldLabel}} <span class="form-field-sublabel-th" v-if="col.fieldSubLabel"><br/>{{col.fieldSubLabel}}</span>
                                            </th>
                                            <th v-if="formPreviewData && formPreviewData.filesEnabled"
                                                style="min-width:100px;max-width:200px;">
                                                Supporting Schedules and Documents
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr >
                                            <td v-for="(col,colIdx) in formPreviewData.formFields"
                                                v-bind:key="colIdx">

                                                <!-- *** INPUT TEXTS *** -->

                                                <!-- Textfield -->
                                                <b-field
                                                    v-if="col.inputType=='textfield'">
                                                    <b-input 
                                                        type="text"
                                                        disabled></b-input>
                                                </b-field>
                                                
                                                <!-- Textarea -->
                                                <b-field
                                                    v-if="col.inputType=='textarea'">
                                                    <b-input 
                                                        maxlength="200" 
                                                        type="textarea"
                                                        disabled></b-input>
                                                </b-field>

                                                <!-- *** NUMBER INPUTS *** -->

                                                <!-- Number -->
                                                <b-field
                                                    v-if="col.inputType=='number'">
                                                    <b-input  
                                                        type="number"
                                                        min="0"
                                                        disabled></b-input>
                                                </b-field>

                                                <!-- Decimal -->
                                                <b-field
                                                    v-if="col.inputType=='decimal'">
                                                    <b-input  
                                                        type="text"
                                                        v-bind:value="''"
                                                        v-cleave="masks.numeral"
                                                        disabled></b-input>
                                                </b-field>

                                                <!-- Integer -->
                                                <b-field
                                                    v-if="col.inputType=='integer'">
                                                    <b-input  
                                                        type="number"
                                                        min="0"></b-input>
                                                </b-field>

                                                <!-- *** SELECTION INPUTS / WITH OPTIONS *** -->

                                                    <!-- Yes or No -->
                                                <b-field
                                                    v-if="col.inputType=='yes or no'">
                                                    <div class="buttons has-addons"
                                                        v-if="col.inputType=='yes or no'">
                                                        <span class="button"
                                                            disabled>Yes</span>
                                                        <span class="button"
                                                            disabled>No</span>
                                                    </div>
                                                </b-field>
                                                
                                                <!-- Dropdown -->
                                                <b-field
                                                    v-if="col.inputType=='dropdown' && col.options.length">
                                                    <!-- Custom Options -->
                                                    <b-select
                                                        v-if="col.optionType=='custom' && col.options.length > 0"
                                                        disabled>
                                                        <option v-for="opt in col.options"
                                                            v-bind:key="opt.optionId"
                                                            v-bind:value="opt.optionValue">
                                                            {{opt.optionValue}}
                                                        </option>
                                                    </b-select>

                                                    <!-- Preset Options -->
                                                    <b-select
                                                        v-if="col.optionType=='preset' && col.options.length==1 && 
                                                        col.options[0].optionValue=='Reporting Entities'"
                                                        disabled>
                                                        <option 
                                                            v-for="(opt,optIdx) in presetLovs['Reporting Entities']"
                                                            v-bind:key="optIdx"
                                                            v-bind:value="opt.optionValue">
                                                            {{opt.optionLabel}}
                                                        </option>
                                                    </b-select>

                                                    <b-select
                                                        v-if="col.optionType=='preset' && col.options.length==1 && 
                                                        col.options[0].optionValue=='Reporting Entities & Units'"
                                                        disabled>
                                                        <option 
                                                            v-for="(opt,optIdx) in presetLovs['Reporting Entities & Units']"
                                                            v-bind:key="optIdx"
                                                            v-bind:value="opt.optionValue">
                                                            {{opt.optionLabel}}
                                                        </option>
                                                    </b-select>
                                                    
                                                </b-field>

                                                <!-- Checkbox -->
                                                <b-field
                                                    v-if="col.inputType=='checkbox' && col.options.length">
                                                    <div class="block">
                                                        <b-checkbox v-for="opt in col.options"
                                                            v-bind:key="opt.optionId"
                                                            v-bind:native-value="opt.optionValue"
                                                            disabled>
                                                            {{opt.optionValue}}
                                                        </b-checkbox>
                                                    </div>
                                                </b-field>

                                                <!-- Radio -->
                                                <b-field
                                                    v-if="col.inputType=='radio' && col.options.length">
                                                    <div class="block">
                                                        <b-radio 
                                                            v-for="opt in col.options"
                                                            v-bind:key="opt.optionId"
                                                            v-bind:name="'radio'+col.fieldId"
                                                            v-bind:native-value="opt.optionValue"
                                                            disabled>
                                                            {{opt.optionValue}}
                                                        </b-radio>
                                                    </div>
                                                </b-field>

                                                <!-- *** DATE INPUT *** -->

                                                <!-- Date Inputs -->
                                                <b-field
                                                    v-if="col.inputType=='date' || 
                                                            col.inputType=='date range (start date)' ||
                                                            col.inputType=='date range (end date)'">
                                                        <b-datepicker
                                                            v-bind:show-week-number="true"
                                                            disabled
                                                            placeholder="Click to select date"
                                                            icon="calendar-today">
                                                        </b-datepicker>
                                                </b-field>

                                            </td>
                                            <td v-if="formPreviewData && formPreviewData.filesEnabled">
                                                <b-field grouped>
                                                    <b-field class="file">
                                                        <b-upload 
                                                            multiple
                                                            disabled>
                                                            <a class="button is-primary is-outlined">
                                                                <b-icon icon="upload"></b-icon>
                                                                <span>Choose file</span>
                                                            </a>
                                                        </b-upload>
                                                    </b-field>
                                                </b-field>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-bind:colspan="formPreviewData.formFields.length + 1">
                                                <a class="button is-light"
                                                    v-if="selectedFormAccessData.formSubmissionType=='Multiple' &&
                                                    selectedFormAccessData.displayOption=='Table'">
                                                    <span class="icon">
                                                        <i class="fas fa-plus"></i>
                                                    </span>
                                                    <span>Add another entry</span>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </section>
                    </div>
                    
                    <!-- Empty State -->
                    <div v-if="selectedFormAccessData==null"
                        class="base-box  box-hw--fill base-box--padded empty-state-box">
                        <!-- Add image here -->
                        <p class="title has-text-grey-light">No access selected</p>
                        <p><br/><br/></p>
                        <!-- <p class="subtitle has-text-grey-light">Please select one from the list to your left.</p> -->
                    </div>
                </div>
            </section>
        </div>

    </section>
</template>

<style scoped>
.field-group-box {
    border: 1px solid #ececec;
    border-radius: 4px;
    padding: 1em;
    margin-top: 0.3em;
}
.app-view--admin {
    max-height: 480px !important;
    min-height: 300px;
}

.checkbox-block > .checkbox,
.radio-block > .radio {
    margin-top: 0.6rem;
    margin-left: 0px;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/PreviewForm.vue